/**
 * Utility to know if something is a number. Pretty basic, we don't look for instances of Number since we don't expect those (for now).
 */
export function isNumber(n) {
    return typeof n === 'number';
}
